module.exports = __webpack_public_path__ + "static/media/video-discurso.14a82624.svg";